import { MenuRoute } from '@blb-ventures/react-components';
import CheckIcon from '@mui/icons-material/Check';
import { OptimizedImage } from '@web/common/components/optimized-image';
import { ParsedUrlQuery } from 'querystring';
import { MouseEvent } from 'react';
import {
  productKindDetails,
  productKindToQueryDict,
  SelectableProductKinds,
} from './store-product-options';

interface GenerateMenuRouteProps<T> extends MenuRoute {
  selectedOption?: T;
  key: T;
  query?: ParsedUrlQuery;
  handleChange?: (e: MouseEvent, opt?: T) => void;
}

const generateMenuRoute = ({
  selectedOption,
  key,
  query,
  handleChange,
  ...props
}: GenerateMenuRouteProps<SelectableProductKinds>): MenuRoute => ({
  ...props,
  endIcon: { icon: selectedOption === key && <CheckIcon color="primary" /> },
  url: `/loja/categoria/${productKindToQueryDict[key]}`,
  onClick: handleChange != null ? e => handleChange(e, key) : undefined,
});

export const getProductKindOptionsDrawer = (
  query?: ParsedUrlQuery,
  selectedProductKind?: SelectableProductKinds,
  handleProductKindOnChange?: (
    e: MouseEvent,
    productKind?: SelectableProductKinds,
  ) => Promise<void> | void,
): MenuRoute[] =>
  [
    {
      label: 'Todas as categorias',
      labelProps: { color: 'textSecondary' },
      icon: <OptimizedImage src="/icons/all-categories.svg" ext="svg" alt="Todas as categorias" />,
      url: '/loja',
      endIcon: { icon: selectedProductKind == null && <CheckIcon color="primary" /> },
    } as MenuRoute,
  ].concat(
    Object.entries(productKindDetails).map(([key, { label, icon }]) =>
      generateMenuRoute({
        label,
        labelProps: { color: 'textSecondary' },
        icon: <OptimizedImage src={icon} ext="svg" alt={label} />,
        selectedOption: selectedProductKind,
        key: key as SelectableProductKinds,
        query,
        handleChange: handleProductKindOnChange,
      }),
    ),
  );
